import React from 'react'

const ErrorCheck = ({ children }) => {
    try {
        return children
    } catch (error) {
        return <div>
            Error
        </div>
    }
}

export default ErrorCheck
